import { FormikErrors, FormikTouched } from 'formik';
import { PropsWithChildren } from 'react';

import styles from 'styles/FormGroup.module.css';

type FormGroupProps = PropsWithChildren & {
  label?: string;
  htmlFor?: string;
  errors?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
  isBtnSubmit?: boolean;
  className?: string;
};

export default function FormGroup({
  children,
  label,
  htmlFor,
  errors,
  touched,
  isBtnSubmit,
  className,
}: FormGroupProps) {
  // Função para extrair mensagens de erro como strings
  const getErrorMessages = () => {
    if (!errors) return null;

    // Se for uma string, retorna diretamente
    if (typeof errors === 'string') {
      return errors;
    }

    // Se for um array de strings, junta com vírgulas
    if (Array.isArray(errors) && errors.every(err => typeof err === 'string')) {
      return errors.join(', ');
    }

    // Se for um objeto FormikErrors, extrai as mensagens
    if (typeof errors === 'object') {
      const flattenErrors = (errObj: FormikErrors<any>): string => {
        let messages: string[] = [];

        const traverse = (obj: FormikErrors<any>) => {
          for (const key in obj) {
            if (typeof obj[key] === 'string') {
              messages.push(obj[key] as string);
            } else if (typeof obj[key] === 'object') {
              traverse(obj[key] as FormikErrors<any>);
            }
          }
        };

        traverse(errObj);
        return messages.join(', ');
      };

      return Array.isArray(errors)
        ? errors.map(err => flattenErrors(err)).join(', ')
        : flattenErrors(errors);
    }

    return null;
  };

  return (
    <div
      className={`${styles.formGroup} ${isBtnSubmit ? styles.isBtnSubmit : ''} ${className}`}
    >
      {label && (
        <label className={styles.label} htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {errors && touched && (
        <div className={styles.formGroup__error}>{getErrorMessages()}</div>
      )}
    </div>
  );
}
